import { useState, useCallback } from "react";
import { isEquivalent } from "../Task";

export const useModalState = () => {
  const [modals, setModals] = useState({
    changeParameter: false,
    getParameter: false,
    confirmRestart: false,
    confirmRecoverSettings: false,
    temperature: false,
  });

  const openModal = useCallback((modalName) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
  }, []);

  const closeModal = useCallback((modalName) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
  }, []);

  return { modals, openModal, closeModal };
};

export const useTasks = () => {
  const [tasks, setTasks] = useState([]);

  const generateTaskId = useCallback(() => Date.now() + Math.random(), []);

  const addTask = useCallback((task) => {
    if (!task || typeof task !== 'object') {
      console.warn("Odrzucono niepoprawny obiekt zadania:", task);
      return;
    }

    if (!task.taskType || typeof task.taskType !== 'string' || task.taskType.trim() === '') {
      console.warn("Odrzucono puste zadanie (brak taskType):", task);
      return;
    }

    if (task.taskType === "PARAM_CHANGE" && (task.value === "" || task.value === null || task.value === undefined)) {
      console.warn("Odrzucono zmianę parametru bez wartości:", task);
      return;
    }

    if (task.taskType === "TEMPERATURE" && (task.value === "" || task.value === null || task.value === undefined)) {
      console.warn("Odrzucono zmianę temperatury bez wartości:", task);
      return;
    }

    if (!task.id) task.id = generateTaskId();
    
    setTasks(currentTasks => {
      const isDuplicate = currentTasks.find(existingTask => isEquivalent(existingTask, task));
      if (isDuplicate) return currentTasks;
      return [...currentTasks, task];
    });
  }, [generateTaskId]);

  const removeTask = useCallback((taskId) => {
    setTasks(currentTasks => currentTasks.filter(task => task.id !== taskId));
  }, []);

  const clearAllTasks = useCallback(() => {
    setTasks([]);
  }, []);

  const updateTaskDateTime = useCallback((taskId, field, value) => {
    setTasks(prevTasks =>
      prevTasks.map(task => {
        if (task.id === taskId) {
          const updatedTask = { ...task };
          if (field === 'startAt' || field === 'dateTimeFrom') {
            updatedTask.startAt = value;
          } else if (field === 'endAt' || field === 'dateTimeTo') {
            updatedTask.endAt = value;
          }
          return updatedTask;
        }
        return task;
      })
    );
  }, []);

  const updateTaskEveryNth = useCallback((taskId, value) => {
    setTasks(prevTasks =>
      prevTasks.map(task => {
        if (task.id === taskId) {
          const val = (value === "" || value === null || value === undefined) ? "" : Number(value);
          return { ...task, everyNth: val };
        }
        return task;
      })
    );
  }, []);

  return {
    tasks,
    addTask,
    removeTask,
    clearAllTasks,
    updateTaskDateTime,
    updateTaskEveryNth,
    generateTaskId
  };
};
